<template>
  <div class="iframIndex">
<!--    {{preUrl}}{{routerPath}}-->
    <iframe
      id="statistics"
      :ref="preUrl"
      :src="getRouter(preUrl,routerPath,routerParms,parmStr)"
      frameborder="0" referrerpolicy="no-referrer"
      width="100%"
      height="100%"
    ></iframe>
  </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import store from '@/store';
    import {encrypt,addClass,removeClass} from '@/util/util'
    import {base64Encode} from '@/util/endecode.js'
    import hrCommon from '@/api/common/hrcloudCommon'
    import router from "../../router/router";
    import {getStoreQ} from '@/util/store'

    export default {
        name: "ifram",
        data(){
            return {
                preUrl: hrCommon.HRCLOUD_URL ,
                routerPath: this.$route.path ,
                routerParms: this.$route.query,
                parmStr: '',
								themeType:'',
            };
        },
        watch: {
            $route: {
                handler: function(val, oldVal){
                    this.routerPath = val.path;
                    this.routerParms = val.query;
                },
                // 深度观察监听
                deep: true
            }
        },
        computed: {
          ...mapGetters([
            'isYgj',
          ])
        },
        filters:{

        },
        mounted(){
          this.themeType = this.$store.getters.themeType;
          var lang = localStorage.getItem('lang');

          if(lang) {
            lang = lang;
          }else{
            lang = "zh";
          }
          if (this.isYgj) {
            this.parmStr=  'lang='+base64Encode(lang)+'&accessToken='+base64Encode(encrypt(this.$store.getters.accessToken,''))+'&themeType='+base64Encode(this.themeType) + '&ygj=' + base64Encode('true');
          } else {
            this.parmStr=  'lang='+base64Encode(lang)+'&accessToken='+base64Encode(encrypt(this.$store.getters.accessToken,''))+'&themeType='+base64Encode(this.themeType);
          }
					this.$nextTick(function(){
						let iframe = document.getElementById('statistics')
						var iwindow = iframe.contentWindow;
						var idoc = iwindow.document;
						addClass(document.getElementsByTagName('body')[0],'pubIndex');
					})

            // iframe.onload = function() {
            //     let data = {
            //         showInfo: true
            //     }
            //     iframe.contentWindow.postMessage(JSON.stringify(data), 'http://localhost:8080');
            // };
            //
            // // 接受domain2返回数据，这边给延迟的原因，因为同步传输时，页面不一定立马拿到数据，所以给延迟
            // setTimeout(function(){
            //     window.addEventListener('message', function(e) {
            //         console.log(e)
            //     }, false);
            // },10)
        },
        destroyed(){
            removeClass(document.getElementsByTagName('body')[0],'pubIndex');
        },
        methods: {
            getRouter:function(preUrl,routePath,routeParms,parmStr){
                addClass(document.getElementsByTagName('body')[0],'pubIndex');
                let preUrlNew = preUrl;
              if (routePath.indexOf('/hrms/wage/wage') != -1) {
                preUrlNew = 'https://payroll.ciicpt.com.cn';
              }
              if (routePath.indexOf('audit_forward') != -1) {
                preUrlNew = 'https://spirent.ciicpt.com.cn';
                if(routePath.indexOf('audit_forward_xsyrzxq') != -1){
                  parmStr="datasid=71ce59e3-daa7-11ed-ac9b-00505693c2db&lang=cn";
                }
                if(routePath.indexOf('audit_forward_xsyrfwtj') != -1){
                  parmStr="datasid=71ce5a18-daa7-11ed-ac9b-00505693c2db&lang=cn";
                }
                if(routePath.indexOf('audit_forward_xcyrzxq') != -1){
                  parmStr="datasid=71ce5a3a-daa7-11ed-ac9b-00505693c2db&lang=cn";
                }
                routePath='/reportermg/showtable';
                console.log(preUrlNew+routePath+parmStr);
              }
                if(routeParms){
                    let routeParmStr = "";
                    for(let key in routeParms){
                        routeParmStr += "&"+key+"="+routeParms[key]
                    }
                  return preUrlNew + routePath + "?" + parmStr + routeParmStr;
                }else{
                  return preUrlNew + routePath +"?"+ parmStr;
                }
                return "";
            }
        }
    }
</script>

<style scoped>
    .iframIndex{
        height: 100%;
        box-sizing: border-box;
    }
</style>
